import { Eventcalendar } from "@mobiscroll/react";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";
import useFetch from "../../clients/features/get_withcredentials";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Calendar() {
  const [events, setEvents] = useState([]);
  const { hotelId } = useParams();

  const { data, loading } = useFetch(
    `https://api.komorotel.com/api/reservation/${hotelId}`
  );

  const colors = [
    "#2563eb",
    "#16a34a",
    "#f59e0b",
    "#ef4444",
    "#7c3aed",
    "#0891b2",
  ];

  const getColorByRoom = (roomTitle) => {
    const index =
      roomTitle
        .split("")
        .reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;

    return colors[index];
  };

  useEffect(() => {
    if (!data) return;

    const formatted = data.map((reservation) => {
      const startDate = new Date(reservation.checkInDate);

      const endDate = new Date(reservation.checkOutDate);
      endDate.setDate(endDate.getDate() - 1); // correction checkout

      return {
        id: reservation._id,
        start: startDate,
        end: endDate,

        title: `${reservation.roomId.title} · ${reservation.guest.firstName}`,

        color: getColorByRoom(reservation.roomId.title),

        cssClass: "fw-semibold",
      };
    });

    setEvents(formatted);
  }, [data]);

  if (loading) {
    return <div>Chargement du calendrier...</div>;
  }

  return (
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <Eventcalendar
        data={events}
        theme="material"
        themeVariant="light"
        width="100%"
        height="650px"

        showEventTooltip={true}

        clickToCreate={false}
        dragToCreate={false}
        dragToMove={false}
        dragToResize={false}

        view={{
          calendar: {
            type: "month",
            labels: true
          },
          agenda: {
            type: "week"
          }
        }}

        onEventClick={(args) => {
          console.log("Reservation :", args.event.id);
        }}
      />
    </div>
  );
}